import { useMutation } from "@tanstack/react-query";
import { usePartyApi } from "../api/party-api";
import type { CustomerQuoteRequestInput, QuoteRequestResult } from "../api/contracts";

// Teklif Al — the authenticated re-quote write (ADR 0005 / System-1). A plain @PartyOnly
// POST: the server resolves the OWN party from the verified customer_sub (no id is trusted,
// none is sent) and returns a NEUTRAL lead handle — never a price/offer (the moat). No query
// invalidation: a quote request creates a lead the advisor works, not a customer-visible read.
export function useCreateQuoteRequest() {
  const api = usePartyApi();
  return useMutation({
    mutationFn: (input: CustomerQuoteRequestInput) =>
      api.post<QuoteRequestResult>("/v1/customer/quote-requests", input),
  });
}
